import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import {Router } from '@angular/router';

@Component({
  selector: 'app-finalitfacility',
  templateUrl: './finalitfacility.component.html',
  styleUrls: ['./finalitfacility.component.scss']
})
export class FinalitfacilityComponent implements OnInit {

  constructor(public appservice:AppService ,public router:Router) { }
 editEmployee(id:any){
  this.appservice.FinalItfacilityeditid=id;
  this.router.navigate(['/home/finalitfacilityrequestform']);
 }
 
  ngOnInit(): void {
    this.appservice.get_finalItFacilitygrid();  
  }

}
